<template>
  <div class="screen">
    <div class="screen-header">
      <img :src="$oss('CorrosionMonitorScreen/title.png')" />
    </div>
    <div class="screen-main">
      <Card name="ditu" :title="`当前站点：${deviceNameMap[deviceSn]}`">
        <Map
          @changeActivePoint="changeActivePoint"
          :noMask="
            !lineData2Loading &&
            !lineData1Loading &&
            !totalDataLoading &&
            !avgDataLoading
          "
        />
      </Card>
      <Card
        name="ripingzhi"
        v-loading="avgDataLoading"
        :hasChannel="true"
        :deviceSn="deviceSn"
        @changeChannel="avgDataChangeChannel"
        element-loading-background="rgba(5, 35, 85, 0.6)"
      >
        <RightTop
          :data="avgData"
          :dataActive="dataActive"
          :deviceSn="deviceSn"
        />
      </Card>
      <div class="screen-main-center flex flex-column">
        <div class="gap"></div>
        <Card
          name="fushijianbao"
          :hasChannel="true"
          :deviceSn="deviceSn"
          @changeChannel="changeChannel($event, 2)"
          v-loading="lineData2Loading"
          element-loading-background="rgba(5, 35, 85, 0.6)"
          ><!-- :name="'fushijianbao'" -->
          <LineChart
            :refresh="randomNumberRefresh2"
            :chartData="lineData2"
            id="lineChart2"
            ref="lineChart2"
            :dataActive="dataActive"
            @dateTimeChange="lineDateTimeChange($event, 2)"
          />
        </Card>
        <Card
          name="shujucaijiliang"
          v-loading="totalDataLoading"
          element-loading-background="rgba(5, 35, 85, 0.6)"
        >
          <CenterBottom :data="totalData" :refresh="randomNumberRefreshTotal" />
        </Card>
      </div>
      <Card
        name="fushitongdao"
        :hasChannel="true"
        :deviceSn="deviceSn"
        @changeChannel="changeChannel($event, 1)"
        v-loading="lineData1Loading"
        element-loading-background="rgba(5, 35, 85, 0.6)"
      >
        <LineChart
          :chartData="lineData1"
          :refresh="randomNumberRefresh1"
          id="lineChart1"
          :dataActive="dataActive"
          ref="lineChart1"
          @dateTimeChange="lineDateTimeChange($event, 1)"
        />
      </Card>
      <Card name="fushirili">
        <RightBottom @dateTimeChange="calendarChange" />
      </Card>
      <LoginDialog v-model="dialogVisible" @loginSuccess="loginSuccess" />
    </div>
  </div>
</template>
<script>
import Card from "./components/card";
import LineChart from "./components/line";
import CenterBottom from "./components/centerBottom";
import Map from "./components/map";
import RightBottom from "./components/rightBottom.vue";
import RightTop from "./components/rightTop.vue";
import lineChartData1 from "./components/line1.json";
import lineChartData1_ from "./components/line1_.json";
import lineChartData2 from "./components/line2.json";
import lineChartData2_ from "./components/line2_.json";
import LoginDialog from "./components/login";
import {
  monitorDataList,
  deviceMonitorData,
  deviceMonitorDataAvg,
  deviceMonitorDataTotal,
  // monitorDataList1,
  // deviceMonitorData1,
  // deviceMonitorDataAvg1,
  // deviceMonitorDataTotal1,
} from "@/api/corrosionMonitorScreen";
import { mapGetters } from "vuex";

export default {
  components: {
    LoginDialog,
    Card,
    LineChart,
    // VBar,
    CenterBottom,
    // CountTo,
    Map,
    RightBottom,
    RightTop,
  },
  data() {
    return {
      lineData1: lineChartData1,
      lineData1_: lineChartData1_,
      lineData2: lineChartData2,
      lineData2_: lineChartData2_,
      channel: 1,
      avgData: null,
      totalData: null,
      realtimeData: null,
      calendarDateTime: [
        // formatDate(new Date()) + " 00:00:00",
        // formatDate(new Date()) + " 23:59:59",
      ],
      dialogVisible: false,
      lineData1Loading: false,
      lineData2Loading: false,
      avgDataLoading: false,
      totalDataLoading: false,
      dataActive: 0,
      deviceSn: "864452066360668",
      randomNumberRefresh1: 0,
      randomNumberRefresh2: 0,
      randomNumberRefreshTotal: 0,
      deviceSnMap: {
        0: "864452066360668",
        1: "865661070939627", // (原：864452066378314)
        2: "864452066378991",
      },
      deviceNameMap: {
        864452066360668: "武汉长丰桥",
        865661070939627: "大气试验场",
        864452066378991: "淡水腐蚀试验场",
      },
    };
  },
  computed: {
    ...mapGetters(["token", "showLogin"]),
  },
  watch: {
    showLogin(val) {
      if (val) {
        this.dialogVisible = true;
      } else {
        this.dialogVisible = false;
      }
    },
  },
  created() {
    this.toLogin();
  },
  methods: {
    changeActivePoint(index) {
      if (!this.token) {
        return this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
      this.dataActive = index;
      // 20251126两个试验场数据改成一样，所以这里只处理一个数据。参数deviceSn不一致
      // this.dataActive === 0
      //   ? (this.deviceSn = "864452066378991")
      //   : (this.deviceSn = "864452066378314");
      this.deviceSn = this.deviceSnMap[index];
      console.log("dataActive", index, this.deviceSn);
      this.getAllInfo();
    },
    loginSuccess() {
      this.getAllInfo();
    },
    toLogin() {
      if (!this.token) {
        this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      } else {
        this.getAllInfo();
      }
    },
    getAllInfo() {
      this.getMonitorData();
      this.getAvgData();
      this.getTotalData();
      //this.getRealtimeData();
    },
    // 切换通道
    changeChannel(channel, index) {
      if (!this.token) {
        return this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
      this["lineData" + index].channel = channel;
      this.getMonitorData(index);
    },
    // 日历选择
    calendarChange(val) {
      if (!this.token) {
        return this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
      this.calendarDateTime = val;
      this.lineData1.dateRange = val;
      this.lineData1_.dateRange = val;
      this.lineData2.dateRange = val;
      this.lineData2_.dateRange = val;
      this.getMonitorData(null, val);
      this.getAvgData();
    },
    // 折线图时间选择
    lineDateTimeChange(range, index) {
      if (!this.token) {
        return this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
      if (range && range.length) {
        this["lineData" + index].dateRange = range;
        this["lineData" + index + "_"].dateRange = range;
      } else {
        this["lineData" + index].dateRange = [];
        this["lineData" + index + "_"].dateRange = [];
      }
      this.getMonitorData(index);
    },
    // 折线图时间初始化,参数num表示减几天
    initDate(num) {
      const today = new Date();
      return new Date(today.setDate(today.getDate() - num));
    },
    async getMonitorData(index, dateRange) {
      let params = {};

      if (!index) {
        const startTime = dateRange ? dateRange[0] : this.initDate(1);
        const endTime = dateRange ? dateRange[1] : this.initDate(0);
        params = {
          queryStartTime: startTime,
          queryEndTime: endTime,
          channelId: 1,
          deviceSn: this.deviceSn,
        };
        this.lineData1.dateRange = [startTime, endTime];
        this.lineData2.dateRange = [startTime, endTime];
        /*if (this.dataActive === 0) {
          this.lineData1.dateRange = [startTime, endTime];
          this.lineData2.dateRange = [startTime, endTime];
        } else {
          this.lineData1_.dateRange = [startTime, endTime];
          this.lineData2_.dateRange = [startTime, endTime];
        }*/
      } else {
        /*let line =
          this.dataActive === 0
            ? this["lineData" + index]
            : this["lineData" + index + "_"];*/
        let line = this["lineData" + index];
        if (!line.dateRange.length) {
          //如果日期区间为空,默认显示通道index近4天数据
          line.dateRange = [this.initDate(4), this.initDate(0)];
        }

        const [start, end] = line.dateRange;
        params = {
          queryStartTime: start,
          queryEndTime: end,
          channelId: line.channel,
          deviceSn: this.deviceSn,
        };
      }
      if (index) {
        index === 1
          ? (this.lineData1Loading = true)
          : (this.lineData2Loading = true);
      } else {
        this.lineData1Loading = true;
        this.lineData2Loading = true;
      }

      const data = await this.$axios.post(
        monitorDataList,
        // this.dataActive === 0 ? monitorDataList : monitorDataList1,
        params
      );
      // 处理武汉市东西湖区点位数据
      /*if (this.dataActive === 0) {
        this.lineData1.datas = [[], [], [], []];
        this.lineData1.times = [];
        this.lineData2.datas = [[], [], []];
        this.lineData2.times = [];

        const setData1 = (i) => {
          this.lineData1.times[i] = data[i].reportTime;
          this.lineData1.datas[0][i] = parseFloat(data[i].measureResistance);
          this.lineData1.datas[1][i] = parseFloat(data[i].referResistance);
          this.lineData1.datas[2][i] = parseFloat(data[i].temperature);
          this.lineData1.datas[3][i] = parseFloat(data[i].humidity);
        };
        const setData2 = (i) => {
          this.lineData2.times[i] = data[i].reportTime;
          this.lineData2.datas[0][i] = parseFloat(data[i].electricCurrent);
          this.lineData2.datas[1][i] = parseFloat(data[i].temperature);
          this.lineData2.datas[2][i] = parseFloat(data[i].humidity);
        };
        if (data.length && index === 1) {
          for (let i = 0; i < data.length; i++) {
            setData1(i);
          }
        } else if (data.length && index === 2) {
          for (let i = 0; i < data.length; i++) {
            setData2(i);
          }
        } else if (data.length && !index) {
          for (let i = 0; i < data.length; i++) {
            setData1(i);
            setData2(i);
          }
        }
      } else {
        // 处理大气试验场点位数据
        this.lineData1_.datas = [[], [], [], [], []];
        this.lineData1_.times = [];
        this.lineData2_.datas = [
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
          [],
        ];
        this.lineData2_.times = [];

        const setData1 = (i) => {
          this.lineData1_.times[i] = data[i].reportTime;
          this.lineData1_.datas[0][i] = parseFloat(data[i].temperature); //空气温度
          this.lineData1_.datas[1][i] = parseFloat(data[i].humidity); //空气湿度
          this.lineData1_.datas[2][i] = parseFloat(data[i].airpress); //气压
          this.lineData1_.datas[3][i] = parseFloat(data[i].soilTemperature); //土壤温度
          this.lineData1_.datas[4][i] = parseFloat(data[i].soilHumidity); //土壤湿度
        };
        const setData2 = (i) => {
          this.lineData2_.times[i] = data[i].reportTime;

          this.lineData2_.datas[0][i] = parseFloat(
            data[i].pmOneZeroConcentration
          ); //PM1.0浓度
          this.lineData2_.datas[1][i] = parseFloat(
            data[i].pmTwoFiveConcentration
          ); //PM2.5浓度
          this.lineData2_.datas[2][i] = parseFloat(data[i].pmTenConcentration); //"PM10浓度
          this.lineData2_.datas[3][i] = parseFloat(data[i].hydrogenSulfide); //硫化氢
          this.lineData2_.datas[4][i] = parseFloat(data[i].sulfurDioxide); //二氧化硫
          this.lineData2_.datas[5][i] = parseFloat(data[i].nitrogenDioxide); //二氧化氮
          this.lineData2_.datas[6][i] = parseFloat(data[i].carbonDioxide); //二氧化碳
          this.lineData2_.datas[7][i] = parseFloat(data[i].carbonMonoxide); //一氧化碳
          this.lineData2_.datas[8][i] = parseFloat(data[i].hydrogenChloride); //氯化氢
          this.lineData2_.datas[9][i] = parseFloat(data[i].ammonia); //氨气
          this.lineData2_.datas[10][i] = parseFloat(data[i].ozone); //臭氧
          this.lineData2_.datas[11][i] = parseFloat(data[i].ultravioletRays); //紫外线
          this.lineData2_.datas[12][i] = parseFloat(data[i].illuminance); //光照度
          this.lineData2_.datas[13][i] = parseFloat(data[i].effectRadiation); //光合有效辐射
          this.lineData2_.datas[14][i] = parseFloat(data[i].totalRadiation); //太阳总辐射
          this.lineData2_.datas[15][i] = parseFloat(data[i].rainfallAmount); //雨量值
          this.lineData2_.datas[16][i] = parseFloat(data[i].windSpeed); //风速
        };
        if (data.length && index === 1) {
          for (let i = 0; i < data.length; i++) {
            setData1(i);
          }
        } else if (data.length && index === 2) {
          for (let i = 0; i < data.length; i++) {
            setData2(i);
          }
        } else if (data.length && !index) {
          for (let i = 0; i < data.length; i++) {
            setData1(i);
            setData2(i);
          }
        }
      }*/

      let setData1 = null;
      let setData2 = null;
      // 淡水腐蚀试验场不需要湿度
      if (this.dataActive === 2) {
        this.lineData1.names = this.lineData1.waterEnvNames;
        this.lineData1.nameUnits = this.lineData1.waterEnvNameUnits;
        this.lineData1.units = this.lineData1.waterEnvUnit;
        this.lineData1.datas = [[], [], []];
        this.lineData1.times = [];
        this.lineData2.names = this.lineData2.waterEnvNames;
        this.lineData2.nameUnits = this.lineData2.waterEnvNameUnits;
        this.lineData2.datas = [[], []];
        this.lineData2.times = [];
        setData1 = (i) => {
          this.lineData1.times[i] = data[i].reportTime;
          this.lineData1.datas[0][i] = parseFloat(data[i].electricCurrent);
          this.lineData1.datas[1][i] = parseFloat(data[i].electricTotal / 1000);
          this.lineData1.datas[2][i] = parseFloat(data[i].temperature);
          // this.lineData1.datas[3][i] = parseFloat(data[i].humidity);
        };
        setData2 = (i) => {
          this.lineData2.times[i] = data[i].reportTime;
          this.lineData2.datas[0][i] = parseFloat(data[i].electricCurrent);
          this.lineData2.datas[1][i] = parseFloat(data[i].temperature);
          // this.lineData2.datas[2][i] = parseFloat(data[i].humidity);
        };
      } else {
        this.lineData1.names = this.lineData1.otherNames;
        this.lineData1.nameUnits = this.lineData1.otherNameUnits;
        this.lineData1.units = this.lineData1.otherUnit;
        this.lineData1.datas = [[], [], [], []];
        this.lineData1.times = [];
        this.lineData2.names = this.lineData2.otherNames;
        this.lineData2.nameUnits = this.lineData2.otherNameUnits;
        this.lineData2.datas = [[], [], []];
        this.lineData2.times = [];

        setData1 = (i) => {
          this.lineData1.times[i] = data[i].reportTime;
          this.lineData1.datas[0][i] = parseFloat(data[i].electricCurrent);
          this.lineData1.datas[1][i] = parseFloat(data[i].electricTotal);
          this.lineData1.datas[2][i] = parseFloat(data[i].temperature);
          this.lineData1.datas[3][i] = parseFloat(data[i].humidity);
        };
        setData2 = (i) => {
          this.lineData2.times[i] = data[i].reportTime;
          this.lineData2.datas[0][i] = parseFloat(data[i].electricCurrent);
          this.lineData2.datas[1][i] = parseFloat(data[i].temperature);
          this.lineData2.datas[2][i] = parseFloat(data[i].humidity);
        };
      }
      if (data.length && index === 1) {
        for (let i = 0; i < data.length; i++) {
          setData1(i);
        }
      } else if (data.length && index === 2) {
        for (let i = 0; i < data.length; i++) {
          setData2(i);
        }
      } else if (data.length && !index) {
        for (let i = 0; i < data.length; i++) {
          setData1(i);
          setData2(i);
        }
      }
      if (index) {
        index === 1
          ? (this.lineData1Loading = false)
          : (this.lineData2Loading = false);
        index === 1
          ? (this.randomNumberRefresh1 = Date.now())
          : (this.randomNumberRefresh2 = Date.now());
      } else {
        this.lineData1Loading = false;
        this.lineData2Loading = false;
        this.randomNumberRefresh1 = Date.now();
        this.randomNumberRefresh2 = Date.now();
      }
    },
    // 均值
    async getAvgData(index = 1) {
      this.avgDataLoading = true;
      const [start, end] = this.calendarDateTime;
      const startTime = start || this.initDate(1);
      const endTime = end || this.initDate(0);
      const params = {
        queryStartTime: startTime,
        queryEndTime: endTime,
        deviceSn: this.deviceSn,
        channelId: index,
      };
      this.avgData = await this.$axios.post(
        deviceMonitorDataAvg,
        // this.dataActive === 0 ? deviceMonitorDataAvg : deviceMonitorDataAvg1,
        params
      );
      this.avgDataLoading = false;
    },
    // 合计值
    async getTotalData() {
      this.totalDataLoading = true;
      const params = {
        deviceSn: this.deviceSn,
      };
      this.totalData = await this.$axios.post(
        deviceMonitorDataTotal,
        // this.dataActive === 0
        //   ? deviceMonitorDataTotal
        //   : deviceMonitorDataTotal1,
        params
      );
      this.totalDataLoading = false;
      this.randomNumberRefreshTotal = Date.now();
    },
    // 实时数据
    async getRealtimeData() {
      this.realtimeData = await this.$axios.get(
        deviceMonitorData
        // this.dataActive === 0 ? deviceMonitorData : deviceMonitorData1
      );
    },

    avgDataChangeChannel(index) {
      if (!this.token) {
        return this.$confirm(`当前页面需要登录后查看, 是否登录？`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("login");
          })
          .catch(() => {
            this.$router.push("/");
          });
      }
      this.getAvgData(index);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/style/variable";
.gap {
  height: calc(100vh / 1080 * 50);
}
.screen {
  position: relative;
  height: 100vh;
  // background: #00132a;
  background: #00132a url($oss-url + "CorrosionMonitorScreen/bg.png") no-repeat
    center center/100% 100%;
  &-login {
    z-index: 1;
    cursor: pointer;
    position: absolute;
    right: calc(100vw / 1920 * 50);
    width: calc(100vw / 1920 * 100);
    height: calc(100vh / 1080 * 50);
    top: calc(100vh / 1080 * 20);
    color: rgba(255, 255, 255, 0.8);
    font-size: calc(100vw / 1920 * 16);

    background: url($oss-url + "screen/login-bg.png") no-repeat center
      center/contain;
  }
  &-header {
    text-align: center;
    padding-top: calc(100vw / 1920 * 50);
    img {
      width: calc(100vw / 1920 * 576);
    }
  }
  &-main {
    position: absolute;
    top: 0;
    width: 100%;
    height: calc(100% - 100vh / 1080 * 40);
    padding: calc(100vh / 1080 * 87) calc(100vw / 1920 * 50)
      calc(100vh / 1080 * 40) calc(100vw / 1920 * 50);
    display: grid;
    gap: calc(100vw / 1920 * 30);
    grid-template-columns: calc(100vw / 1920 * 460) auto calc(
        100vw / 1920 * 460
      );
    grid-template-rows: 50% 50%;
    &-center {
      grid-row: 1 / 3;
      grid-column-start: 2;
      display: grid;
      grid-template-rows: 5% calc(60% - calc(100vh / 1080 * 60)) 35%;
      gap: calc(100vh / 1080 * 30);
    }
  }
}
</style>
